module.exports = __webpack_public_path__ + "static/img/guangg2.cf485ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guangg2.jpg
// module id = RFf6
// module chunks = 38